// src/components/msteams-link-user/MsTeamsLinkUser.tsx
import React, { useMemo } from "react";
import { useNovu } from "../../hooks/NovuProvider.js";
import { NovuUI } from "../NovuUI.js";
import { withRenderer } from "../Renderer.js";
import { DefaultMsTeamsLinkUser } from "./DefaultMsTeamsLinkUser.js";
import { jsx } from "react/jsx-runtime";
var MsTeamsLinkUserInternal = withRenderer((props) => {
  const { container, appearance, ...defaultProps } = props;
  const novu = useNovu();
  const options = useMemo(() => {
    return {
      container,
      appearance,
      options: novu.options
    };
  }, [container, appearance, novu.options]);
  return /* @__PURE__ */ jsx(NovuUI, { options, novu, children: /* @__PURE__ */ jsx(DefaultMsTeamsLinkUser, { ...defaultProps }) });
});
MsTeamsLinkUserInternal.displayName = "MsTeamsLinkUserInternal";
var MsTeamsLinkUser = React.memo((props) => {
  return /* @__PURE__ */ jsx(MsTeamsLinkUserInternal, { ...props });
});
MsTeamsLinkUser.displayName = "MsTeamsLinkUser";
export {
  MsTeamsLinkUser
};
//# sourceMappingURL=MsTeamsLinkUser.js.map